import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "requisites__container" }
const _hoisted_2 = { class: "requisites__block" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "mt-3 mb-1 text-capitalize-first" }
const _hoisted_5 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = ["onUpdate:modelValue", "disabled"]
const _hoisted_8 = { class: "requisites__content" }
const _hoisted_9 = { class: "d-flex align-items-center gap-2" }
const _hoisted_10 = ["onUpdate:modelValue", "disabled", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = { class: "switch" }
const _hoisted_15 = ["onUpdate:modelValue", "disabled"]
const _hoisted_16 = {
  class: "form-check-label",
  for: "bulkBlacklistAgreement"
}
const _hoisted_17 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_18 = { class: "requisites__controls" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    onOnClose: _ctx.hide,
    title: _ctx.$t('requisites.bulk_edit.title', {count: _ctx.items.length})
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "requisites",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('requisites.bulk_edit.hint')), 1),
            _createVNode(_component_FormInputWrapper, {
              field: "ids",
              form: "requisitesBulk"
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass(parentProps.class)
                }, null, 2)
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: section.key
            }, [
              _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t(`requisites.bulk_edit.section.${section.key}`)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: field.name,
                  class: "requisites__block align-items-start"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input flex-shrink-0 mt-0",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.enabled[field.name]) = $event),
                        disabled: _ctx.isFieldDisabled(field)
                      }, null, 8, _hoisted_7), [
                        [_vModelCheckbox, _ctx.enabled[field.name]]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(field.label)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (field.kind === 'sum' || field.kind === 'count')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_FormInputWrapper, {
                            field: `changes[${field.name}]`,
                            form: "requisitesBulk"
                          }, {
                            default: _withCtx((parentProps) => [
                              _createElementVNode("div", _hoisted_9, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.name]) = $event),
                                  disabled: !_ctx.enabled[field.name],
                                  class: _normalizeClass([parentProps.class, "form-control"]),
                                  placeholder: field.nullable ? '' : '0',
                                  "data-maska": "9 99#",
                                  "data-maska-tokens": "9:[0-9]:repeated",
                                  "data-maska-reversed": "",
                                  type: "text"
                                }, null, 10, _hoisted_10), [
                                  [_vModelText, _ctx.values[field.name]],
                                  [_directive_maska]
                                ]),
                                (field.kind === 'sum' && _ctx.currency)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.currency), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["field"]),
                          (field.kind === 'sum' && _ctx.mixedCurrency)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('requisites.bulk_edit.mixed_currency')), 1))
                            : (_ctx.enabled[field.name])
                              ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(field.nullable ? _ctx.$t('requisites.bulk_edit.empty_to_clear') : _ctx.$t('requisites.bulk_edit.empty_is_zero')), 1))
                              : _createCommentVNode("", true)
                        ], 64))
                      : (field.kind === 'flag')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("label", _hoisted_14, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.name]) = $event),
                                disabled: !_ctx.enabled[field.name]
                              }, null, 8, _hoisted_15), [
                                [_vModelCheckbox, _ctx.values[field.name]]
                              ]),
                              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "slider" }, null, -1))
                            ]),
                            (field.name === 'isActive')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["ms-2", {'text-muted': !_ctx.enabled[field.name]}])
                                }, _toDisplayString(_ctx.values[field.name] ? _ctx.$t('requisites.bulk_edit.active_on') : _ctx.$t('requisites.bulk_edit.active_off')), 3))
                              : _createCommentVNode("", true),
                            (field.name === 'isActive' && _ctx.needsAgreement)
                              ? (_openBlock(), _createBlock(_component_FormInputWrapper, {
                                  key: 1,
                                  field: "isAgreeBlacklistPaymentMethod",
                                  form: "requisitesBulk"
                                }, {
                                  default: _withCtx((parentProps) => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["mt-2", parentProps.class])
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAgreeBlacklistPaymentMethod) = $event)),
                                        type: "checkbox",
                                        id: "bulkBlacklistAgreement"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.isAgreeBlacklistPaymentMethod]
                                      ]),
                                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('labels.agree_with_risk')), 1)
                                    ], 2)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (field.kind === 'switchOff')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: _normalizeClass({'text-muted': !_ctx.enabled[field.name]})
                            }, _toDisplayString(_ctx.$t('requisites.bulk_edit.white_triangle_off')), 3))
                          : (field.kind === 'action')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: _normalizeClass({'text-muted': !_ctx.enabled[field.name]})
                              }, _toDisplayString(_ctx.$t(field.hint || '')), 3))
                            : (field.kind === 'group')
                              ? (_openBlock(), _createBlock(_component_FormInputWrapper, {
                                  key: 4,
                                  field: `changes[${field.name}]`,
                                  form: "requisitesBulk"
                                }, {
                                  default: _withCtx((parentProps) => [
                                    _createVNode(_component_Multiselect, {
                                      class: _normalizeClass(["multiselect-sm", parentProps.class]),
                                      modelValue: _ctx.values[field.name],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.name]) = $event),
                                      disabled: !_ctx.enabled[field.name],
                                      options: _ctx.groupOptions,
                                      "custom-label": _ctx.groupLabel,
                                      multiple: false,
                                      "allow-empty": false,
                                      "select-label": "Select",
                                      placeholder: _ctx.$t('labels.req_group')
                                    }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "disabled", "options", "custom-label", "placeholder"])
                                  ]),
                                  _: 2
                                }, 1032, ["field"]))
                              : (field.kind === 'device')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _createVNode(_component_FormInputWrapper, {
                                      field: `changes[${field.name}]`,
                                      form: "requisitesBulk"
                                    }, {
                                      default: _withCtx((parentProps) => [
                                        _createVNode(_component_Multiselect, {
                                          class: _normalizeClass(["multiselect-sm", parentProps.class]),
                                          modelValue: _ctx.values[field.name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.values[field.name]) = $event),
                                          disabled: !_ctx.enabled[field.name],
                                          options: _ctx.deviceOptions,
                                          "custom-label": _ctx.deviceLabel,
                                          multiple: false,
                                          "allow-empty": false,
                                          "select-label": "Select",
                                          placeholder: _ctx.$t('labels.device')
                                        }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "disabled", "options", "custom-label", "placeholder"])
                                      ]),
                                      _: 2
                                    }, 1032, ["field"]),
                                    (_ctx.enabled[field.name])
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.$t('requisites.bulk_edit.device_warning')), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn",
            type: "button",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode(_component_LoaderButton, {
            "on-click": _ctx.save,
            class: "btn btn--accept"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('button.save')), 1)
            ]),
            _: 1
          }, 8, ["on-click"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["onOnClose", "title"]))
}